import { Component, OnInit,Input, Renderer2, ElementRef } from '@angular/core';
import { LoadingController, ModalController } from '@ionic/angular';
import { meetingData_pObj } from '../../../../services/payload/meetingData_pobj'
import { BettingServiceService } from '../../../../services/betting_service/betting-service.service';
import { CommonServiceService } from '../../../../services/common_service/common-service.service';
import { StmgService } from '../../../../services/state_Management/stmg.service';
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription, timer } from 'rxjs';
import { UserServiceService } from 'src/app/services/user_service/user-service.service';
import { PlayerModalComponent } from '../../../alert/player-modal/player-modal.component';

@Component({
  selector: 'app-in-play-odds',
  templateUrl: './in-play-odds.component.html',
  styleUrls: ['./in-play-odds.component.scss'],
})
export class InPlayOddsComponent implements OnInit {

  @Input() selectedBetCategory: any;
  ODDs : any = [];
  viewSelectionBlock : boolean;
  tempObj: any = [];
  selectedMeeting : any;
  shownOdd: any;

  selectionType:string = "";
  maxCount:boolean = false;
  selection: any = {
    eventSelections: []
  };
  subscription: Subscription;
  disable_SP_subscription: Subscription;
  matchWinner: string;
  allData: any;
  
  // odd refresh
  oddRefresh: Subscription;
  counter = 30;
  scrollId: string;

  currentSelectedBets: any = null;    // Block Games

  is_logged = false;
  private isLiveVideoModalOpen = false;
  private isLiveVideoLoading = false;

  videoEligibility = new Map<number, boolean>();

  constructor(
    public modalController: ModalController,
    private bettingService:BettingServiceService,
    private commanService: CommonServiceService,
    public alertController: AlertController,
    private stmgService:StmgService,public renderer: Renderer2,
    public translate: TranslateService,public ele: ElementRef,
    private userService: UserServiceService,
    private loadingController: LoadingController
  ) {
    //refresh when remove all from bet slip modal
    this.disable_SP_subscription = this.commanService.getClickEvent().subscribe(() => {
      //this.getMeetingData(this.selectedBetCategory);
      //this.ngOnInit();
      //this.ngOnChanges(); 
      this.ODDs.forEach(element => {
        if (element.matchWinner.length > 0) {
          element.matchWinner.forEach(element2 => {
            let i = 0;
            element2.clicked = false;
            i++;
          });
        }
      });

    })
  }

  ngOnInit() {
    this.stmgService.is_logged_status.subscribe(message =>
      this.is_logged = message
    );

    this.viewSelectionBlock = false;
    this.stmgService.cast_clickStatus.subscribe(clicked => {
      this.viewSelectionBlock = clicked;
      if(!clicked){
        let el = document.getElementById(this.scrollId);
        setTimeout(() => {
          el.scrollIntoView();
        }, 100);
      }
    });

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if(selectedBets){
        this.selection = selectedBets;
      }
    });

    // Block Games
    this.stmgService.cast_selectedBets.subscribe(bets => {
      this.currentSelectedBets = bets;
      // console.log('Game - Subscription updated:', bets);
    });

    this.stmgService.nav2InplayRefresh_status.subscribe(clicked => {
      if(clicked=='yes'){
        this.ngOnChanges();
      }
    });
   
    this.is_no_data=false;

    
    // Odd Refresh - run every 30 sec.
    this.oddRefresh = interval(30000).subscribe((x => {
      this.getMeetingData(this.selectedBetCategory);
      this.counter = 30;
    }));
  }

  ngOnChanges(){
    if ((this.selectedBetCategory && this.selectedBetCategory.sportCode == "BB") || (this.selectedBetCategory && this.selectedBetCategory.sportCode == "IH")) {
      this.matchWinner = "Match Result";
    } else if(this.selectedBetCategory && this.selectedBetCategory.sportCode == "BX"){
      this.matchWinner = "Fight Winner";
    }
    else {
      this.matchWinner = "Match Winner";
    }
    this.ODDs  = [];
    this.tempObj = [];
    this.viewSelectionBlock = false;
    this.getMeetingData(this.selectedBetCategory);

    this.subscription = this.stmgService.cast_selectedBets.subscribe(selectedBets => {
      if(selectedBets){
        this.selection = selectedBets;
      }
    });
    this.is_no_data=false;
  }

  
  viewSportDetails(d:any,event) {
    let myTag = this.ele.nativeElement.querySelectorAll(".sub-item");
    myTag.forEach(ele => {
      ele.classList.remove('sub-item-selected');
    })

    let element=event.target;
    for (let index = 0; index < 10; index++) {
      if (element.classList.contains('sub-item')){
        this.renderer.addClass(element, 'sub-item-selected');
        break;
      }else{
        element=element.parentNode;
      }
    }

    this.viewSelectionBlock = true;
    this.selectedMeeting = d; 
  }

  getOddData(oddId){
    this.shownOdd = '';
    if (this.isOddShown(oddId)) {
      this.shownOdd = null;
    } else {
      this.shownOdd = oddId;
    }
  }

  isOddShown(id){
    return this.shownOdd === id;
  }

  // Get Meeting Data
  getMeetingData(data : any){
    if(data != undefined){
      let meetingPayload = new meetingData_pObj();
      meetingPayload.country = data.country;
      meetingPayload.date = this.commanService.getCurrentDateTime();
      meetingPayload.filter = data.filter;
      meetingPayload.inplay = data.inplay;
      meetingPayload.sport = data.sportCode;
  
      let payload={
        filter:3,
        inplay:true,
        sport:data.sportCode
      }

      if(data.showMatchWinner==0){
        payload.filter=2;
      }
  
      this.bettingService.getSportMeetingData(payload).subscribe(data =>{
        this.validatePayload(data);
      },(error)=>{
      
      });
      
    }

  }

  is_no_data=false;
  validatePayload(data:any){
    if(data.status !== 'success' || !data.payload.length){
      // let alert = new AlertComponent(this.alertController);
      // alert.launchAlert("", "Event Info", "No Events for this Sports Category");
      this.is_no_data=true;
    }else{
      this.createSportDataObj(data);
      this.updateMeetingDataSTMG(data);
    }
  }

  createSportDataObj(data) {
 
    let tempData = data.payload;
    this.allData = data.payload;
    let selectedId: number=-1;

    for (let i = 0; i < tempData.length; i++) {

      let meetingName = tempData[i].meetingName;
  
      // Regex to match " vs ", " v ", or " @ "
      let teams = meetingName.split(/\s+(?:vs\.?|v|@)\s+/i);

      let vsRegex = /\bvs\.?\b/;
      let atRegex = / @ /; 

      let matchSeperatorType = vsRegex.test(meetingName) ? "vs" : atRegex.test(meetingName) ? "@" : "v";


      this.tempObj[i] = {
        id: tempData[i].meetingId,
        eventId: tempData[i].eventId,
        meetingId: tempData[i].meetingId,
        hasLiveVideo: tempData[i].hasLiveVideo,
        meetingName: tempData[i].meetingName,
        meetingLocalTime: tempData[i].meetingLocalTime,
        tourName: tempData[i].tourName,
        sel1Name: teams[0],
        sel2Name: teams[1],
        matchType: matchSeperatorType,
        eventData: [],
        matchWinner: [{
          id: tempData[i].sel1Id,
          name: tempData[i].sel1Name,
          lastOddDec: tempData[i].sel1PriceDec,
          sel1PriceFrac: tempData[i].sel1PriceFrac,
          Status: tempData[i].sel1Status
        },
        {
          id: tempData[i].sel2Id,
          name: tempData[i].sel2Name,
          lastOddDec: tempData[i].sel2PriceDec,
          sel1PriceFrac: tempData[i].sel2PriceFrac,
          Status: tempData[i].sel2Status
        },
        {
          id: tempData[i].sel3Id,
          name: tempData[i].sel3Name,
          lastOddDec: tempData[i].sel3PriceDec,
          sel1PriceFrac: tempData[i].sel3PriceFrac,
          Status: tempData[i].sel3Status
        }
        ]
      };

      if (tempData[i].meetingMetaData !== undefined) {
        this.tempObj[i].meetingMetaData =JSON.parse(tempData[i].meetingMetaData) 
      }
      
       //if draw position changed swap the macth winner position
      if(this.tempObj[i].matchWinner[1].name=="Draw" || this.tempObj[i].matchWinner[1].name=="Tie"){
        this.tempObj[i].matchWinner[2]={
          id: tempData[i].sel2Id,
          name: tempData[i].sel2Name,
          lastOddDec: tempData[i].sel2PriceDec,
          sel1PriceFrac: tempData[i].sel2PriceFrac,
          Status: tempData[i].sel2Status
        }

        this.tempObj[i].matchWinner[1]={
          id: tempData[i].sel3Id,
          name: tempData[i].sel3Name,
          lastOddDec: tempData[i].sel3PriceDec,
          sel1PriceFrac: tempData[i].sel3PriceFrac,
          Status: tempData[i].sel3Status
        }
      }

      let meetingPayload = new meetingData_pObj();
      meetingPayload.country = this.selectedBetCategory.country;
      meetingPayload.date = this.commanService.getCurrentDateTime();
      meetingPayload.filter = this.selectedBetCategory.filter;
      meetingPayload.inplay = this.selectedBetCategory.inplay;
      meetingPayload.sport = this.selectedBetCategory.sportCode;

      if(this.selectedBetCategory.showMatchWinner==1){
        meetingPayload.id = this.tempObj[i].id;
      }else{
        meetingPayload.id = tempData[i].id;
      }
      
      // get meetings by event id
      this.bettingService.getMeetingDataById(meetingPayload).subscribe(data => {
        let d = this.trimObj(data);

        if(d){
          for (let m = 0; m < d.length; m++) {
            this.tempObj[i].eventData.push(d[m]);
          }
        }
      }, (error) => {

      });
    }
    this.ODDs = this.tempObj;

    // load eleigibility for events that have live video
    this.loadVideoEligibility(this.ODDs);
  }

  trimObj(data:any){
    let trimObjData;
    if(data.payload[0]){
      trimObjData = data.payload[0].eventLightDTOs;
    }
    return trimObjData;
  }

  updateMeetingDataSTMG(d:any){
    this.stmgService.updateMeetingData(d);
  }


  setSPOdd(value: any) {
    if (this.currentSelectedBets && this.currentSelectedBets !== '') {
      console.log('In play - Inside check, currentBets exists');
      
      const isKironGame = this.currentSelectedBets.payload && (this.currentSelectedBets.payload['@rule'] === 'FeedId88BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId86BettingOptions' || this.currentSelectedBets.payload['@rule'] === 'FeedId87BettingOptions');
      console.log('Inside In play  - Games Bets includes :', isKironGame);
      
      if (isKironGame && this.currentSelectedBets.payload.eventSelections) {
        const hasGameBets = this.currentSelectedBets.payload.eventSelections.length > 0;
        console.log('Inside In play  - hasGameBets:', hasGameBets);
        
        if (hasGameBets) {
          this.showBlockAlert();
          return;
        }
      }
    }

    this.selectionType = 'SP';
    value.clicked = !value.clicked;

    if (value.clicked == true) {
      this.maxCount = this.checkMaximuSelectionCount();
      if (this.maxCount == false) {
        this.placeBetObj(value, this.selectionType);
      } else {
        value.clicked = false;
        this.showMaxCountAlert();
      }
    } else {
      this.placeBetObj(value, this.selectionType);
    }
  }

  showBlockAlert() {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get('ALERTS.BLOCK_SELECTIONS.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get('ALERTS.BLOCK_SELECTIONS.DESC').subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }


  checkMaximuSelectionCount(){
    let val: boolean;
    let selectionArray=this.selection.eventSelections.filter(m=>!m.isKR3)
    if(selectionArray.length == 4){
      val = true;
    }else{
      val = false;
    }
    return val;
  }


  placeBetObj(d:any,t:string){
    let oddD: any;
    let oddF: any;
    let win: number = 0;
    let place: number = 0;

    switch(t){

      case'SP':
      oddF = 'N';
      oddD = 0.0;
      break;

      case'PO':
      oddF = d.priceOdds.priceFraction;
      oddD = 0.0;
      break;

      case'PD':
      oddF = 'N';
      oddD = d.priceOdds.priceDecimal;
      break;

    }

    let tempObj = {
      id: d.id,
      oddD: oddD,
      oddF: oddF,
      win: win,
      place: place,
      sportType: d.id
    }

    if(d.clicked == true){
      this.maxCount = this.checkMaximuSelectionCount();
      let index = -1;
      for(let i = 0 ; i < this.selection.eventSelections.length; i++){

        if(this.selection.eventSelections[i].id == d.id){
          index = i;
          break;
        }

      }

      // add row
      if(index == -1){        
        this.selection.eventSelections.push(tempObj);
      }
     
      
    }else{
      let index = -1;
      for(let i = 0 ; i < this.selection.eventSelections.length; i++){

        if(this.selection.eventSelections[i].id == d.id){
          index = i;
          // remove row
          this.selection.eventSelections.splice(index, 1);
          break;
        }

      }
    }

      this.stmgService.updateSelecteBets(this.selection);
  }


  showMaxCountAlert(){
    let alertTitle:string;
      let alertDesc:string;
      this.translate.get('ALERTS.MAX_COUNT.TITLE').subscribe((res: string) => {
        alertTitle=res;
      });
      this.translate.get('ALERTS.MAX_COUNT.DESC').subscribe((res: string) => {
        alertDesc=res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.launchAlert("",alertTitle,alertDesc);
  }


  //stop the 30 seconds loop
  ngOnDestroy() {
    this.oddRefresh.unsubscribe();
  }


  
  colorChange(event,i){
    this.scrollId="scrollto"+i

    let myTag = this.ele.nativeElement.querySelectorAll(".betting-category");
      myTag.forEach(ele => {
        ele.classList.remove('selected');
      })

    let element=event.target;
    for (let index = 0; index < 10; index++) {
      if (element.id == "dropdown"){
        this.renderer.addClass(element, 'selected');
        break;
      }else{
        element=element.parentNode;
      }
    }
  }

  loadVideoEligibility(meetings: Array<{ meetingId: number; hasLiveVideo: boolean }>): void {
    this.videoEligibility.clear();

    if (!this.is_logged) {
      return;
    }

    let token = this.commanService.getToken();

    if (!token) {
      return;
    }

    const meetingIds = meetings
      .filter(meeting => meeting.hasLiveVideo)
      .map(meeting => meeting.meetingId);

    const body = {
      meetingIds: meetingIds,
      token: token
    }

    this.userService.getVideoEligibility(body).subscribe({
      next: response => {
        if (response.status === 'success' && response.payload) {
          response.payload.forEach((item:any) => {
            this.videoEligibility.set(Number(item.meetingId), item.eligible);
          });
        }
      },
      error: () => {
        // Leave eligibility unknown; do not treat API failures as ineligible.
      }
    });
  }

  getVideoEligibilityState(meetingId: number | string): boolean | undefined {
    return this.videoEligibility.get(Number(meetingId));
  }

  async onLiveVideoClick(odd: any, event: Event): Promise<void> {
    event.stopPropagation();

    if (this.isLiveVideoLoading || this.isLiveVideoModalOpen) {
      return;
    }

    if (!this.is_logged) {
      let alertTitle: string;
      let alertDesc: string;
      this.translate.get('ALERTS.LOGTO_VIDEO.TITLE').subscribe((res: string) => {
        alertTitle = res;
      });
      this.translate.get('ALERTS.LOGTO_VIDEO.DESC').subscribe((res: string) => {
        alertDesc = res;
      });
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", alertTitle, alertDesc);
      return;
    }

    if (odd?.meetingId == null) {
      this.showAlertCommon('ALERTS.LIVE_VIDEO_EVENT_ID_MISSING.TITLE', 'ALERTS.LIVE_VIDEO_EVENT_ID_MISSING.DESC')
      return;
    }
    
    this.isLiveVideoLoading = true;
    let loading: HTMLIonLoadingElement;
    let videoUrl: string;
    let providerMessage: string;
    let alertKey = 'ALERTS.UNABLE_TO_CHECK_ELIGIBILITY';

    try {
      const message = await this.translate.get('ALERTS.LOADING.TITLE').toPromise();
      loading = await this.loadingController.create({
        message,
        translucent: true,
        backdropDismiss: false
      });
      await loading.present();

      const token = this.commanService.getToken();
      const response = await this.userService.checkVideoEligibility({
        meetingId: odd.meetingId,
        token
      }).toPromise();

      if (response?.status === 'success' && response.payload?.eligible === true) {
        alertKey = 'ALERTS.LIVE_UNABLE_TO_ACCESS';
        const videoResponse = await this.userService.getVideoAccess({
          meetingId: odd.meetingId,
          token
        }).toPromise();
        const payload = videoResponse?.payload;

        if (payload?.available === true && payload?.url) {
          videoUrl = payload.url;
        } else {
          providerMessage = payload?.message;
          alertKey = 'ALERTS.LIVE_IS_NOT_AVAILABLE';
        }
      } else {
        providerMessage = response?.payload?.message;
        alertKey = 'ALERTS.LIVE_NOT_ELIGIBLE';
      }
    } catch {
      // alertKey identifies which request failed.
    } finally {
      try {
        if (loading) {
          await loading.dismiss();
        }
      } finally {
        this.isLiveVideoLoading = false;
      }
    }

    // Dismiss the loader before displaying either the player or an alert.
    if (videoUrl) {
      await this.openLiveVideo(videoUrl);
    } else if (providerMessage) {
      const alert = new AlertComponent(this.alertController);
      alert.launchAlert('', 'Live Video', providerMessage);
    } else {
      this.showAlertCommon(`${alertKey}.TITLE`, `${alertKey}.DESC`);
    }
  }

  async openLiveVideo(videoUrl: string): Promise<void> {
    if (this.isLiveVideoModalOpen) {
      return;
    }

    this.isLiveVideoModalOpen = true;
    try {
      const modal = await this.modalController.create({
        component: PlayerModalComponent,
        componentProps: { 
          videoUrl, 
          posterUrl: 'assets/images/cricket-live-banner.png'
        },
        cssClass: 'customPopup'
      });
      await modal.present();
      await modal.onDidDismiss();
    } catch {
      this.showAlertCommon('ALERTS.LIVE_UNABLE_TO_ACCESS.TITLE', 'ALERTS.LIVE_UNABLE_TO_ACCESS.DESC');
    } finally {
      this.isLiveVideoModalOpen = false;
    }
  }

  showAlertCommon(title:string, desc:string) {
    let alertTitle: string;
    let alertDesc: string;
    this.translate.get(title).subscribe((res: string) => {
      alertTitle = res;
    });
    this.translate.get(desc).subscribe((res: string) => {
      alertDesc = res;
    });
    let alert = new AlertComponent(this.alertController);
    alert.launchAlert("", alertTitle, alertDesc);
  }
  
}
